module.exports = __webpack_public_path__ + "img/y4.f2ca7e91.webp";